<template>
  <div
    :class="{ 'service-detail--horizontal': horizontal }"
    class="service-detail"
  >
    <div class="service-detail__title">
      {{ serviceData.title }}
    </div>
    <div class="service-detail__photo">
      <img
        v-for="(tab, index) in serviceData.list"
        :key="tab.title"
        v-show="currentTab === index"
        :src="`/images/heum-report/${serviceType}-${tab.title}.png`"
        alt=""
      />
    </div>
    <div class="service-detail__tabs">
      <button
        v-for="(tab, index) in serviceData.list"
        :key="index"
        :class="{ 'service-detail__tab--active': currentTab === index }"
        @click="changeTabContent(index)"
        class="service-detail__tab"
      >
        {{ tab.title }}
      </button>
    </div>
    <div class="service-detail__description">
      <p
        v-for="(tab, index) in serviceData.list"
        :key="tab.title"
        v-show="currentTab === index"
      >
        <span v-html="tab.description"></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    serviceData: {
      type: Object,
      required: true
    },
    serviceType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    currentTab: 0
  }),
  methods: {
    changeTabContent(index) {
      this.currentTab = index
    }
  }
}
</script>

<style lang="scss">
.service-detail {
  padding: 4.5rem 1rem 2.5rem;
  text-align: center;

  @include av-mq(lap-and-up) {
    padding: 7.5rem 1rem 4.5rem;
  }

  &__title {
    margin: 0 auto 1rem;
    font-size: 26px;
    text-align: center;
    line-height: 1.48;
    color: #323438;
    word-break: keep-all;

    @include av-mq(pocket) {
      max-width: 240px;
    }

    @include av-mq(lap-and-up) {
      max-width: auto;
      font-size: 32px;
      margin-bottom: 2rem;
    }
  }

  &__photo {
    margin-bottom: 0.5rem;
    img {
      max-width: 100%;
    }
  }

  &__tabs {
    margin: 0 -1rem 1.5rem;
    text-align: center;

    @include av-mq(lap-and-up) {
      margin: 0 0 2rem;
    }
  }

  &__tab {
    display: inline-block;
    margin: 0 8px;
    padding: 0.25rem 0;
    border: 0;
    background: none;
    letter-spacing: -1px;
    color: #878d91;

    @media screen and (max-width: 360px) {
      font-size: 14px;
      letter-spacing: -1.5px !important;
    }

    @include av-mq(handheld-and-up) {
      margin: 0 20px;
      font-size: 16px;
    }

    @include av-mq(lap-and-up) {
      font-size: 20px;
    }

    &--active {
      color: initial;
      border-bottom: 3px solid #1f75e8;
    }
  }

  &__description {
    text-align: center;
    line-height: 1.5;
    color: #323438;
    word-break: keep-all;
    opacity: 0.8;

    @media screen and (max-width: 360px) {
      min-height: 42px;
      font-size: 14px;
    }

    @include av-mq(handheld-and-up) {
      min-height: 48px;
      font-size: 16px;
    }

    @include av-mq(lap-and-up) {
      min-height: 60px;
      font-size: 20px;
    }
  }
}

.service-detail--horizontal {
  @include av-mq(desk) {
    @include clearfix;
    position: relative;
    min-height: 720px;
    padding: 0 1rem !important;

    .service-detail__title {
      text-align: left;
      margin-bottom: 3rem;
      padding-top: 252px;
    }

    .service-detail__photo {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }

    .service-detail__tabs {
      text-align: left;
    }

    .service-detail__tab {
      margin: 0 20px 0 0;
    }

    .service-detail__description {
      text-align: left;
      max-width: 500px;
      line-height: 1.4;
    }
  }
}
</style>
